import {CompanySuggestionResource} from '@/common/api/api-raw-types';
import {CompanySuggestion} from '../../../domain/experience/Experience';

export function toCompanySuggestion(companySuggestionResource: CompanySuggestionResource): CompanySuggestion {
    return {
        companyId: companySuggestionResource.key,
        name: companySuggestionResource.text,
    };
}
